export const LANDING_PAGES = [
  {
    slug: 'rent-in-ibadan',
    title: 'Rent in Ibadan | Verified Homes with 30% Upfront | LiteRent',
    metaTitle: 'Rent in Ibadan | LiteRent',
    description: 'Looking for rent in Ibadan? LiteRent helps eligible renters move into verified homes with 30% upfront and spread the balance over time.',
    heading: 'Rent in Ibadan without one full year upfront',
    intro: 'LiteRent helps working renters in Ibadan access verified homes with a simpler move-in structure. Browse available homes, understand typical price ranges, and see how LiteRent reduces upfront stress.',
    heroTag: 'Ibadan rent guide',
    location: 'Ibadan',
    minRent: '',
    maxRent: '',
    bedrooms: '',
    faq: [
      ['How does LiteRent work for renters in Ibadan?', 'LiteRent helps eligible renters move into verified homes with 30% upfront and then spread the balance over time.'],
      ['Are these homes verified?', 'LiteRent focuses on verified homes and transparent rental information so renters can apply with more confidence.'],
      ['Can I browse by area or bedroom count?', 'Yes. Use the browse page or the linked area and bedroom pages to narrow down homes that fit your budget and space needs.'],
    ],
    related: ['apartments-in-ibadan', 'verified-homes-in-ibadan', 'cheap-houses-in-ibadan', '2-bedroom-flats-for-rent-in-ibadan'],
  },
  {
    slug: 'apartments-in-ibadan',
    title: 'Apartments in Ibadan | Verified Apartments with 30% Upfront | LiteRent',
    metaTitle: 'Apartments in Ibadan | LiteRent',
    description: 'Browse apartments in Ibadan on LiteRent and see verified homes that eligible renters can access with 30% upfront and the balance spread over time.',
    heading: 'Apartments in Ibadan made easier to access',
    intro: 'From compact flats to family apartments, LiteRent helps you browse homes in Ibadan with clear pricing, verified details, and a structured move-in plan.',
    heroTag: 'Apartment listings',
    location: 'Ibadan',
    minRent: '',
    maxRent: '',
    bedrooms: '',
    faq: [
      ['What kinds of apartments can I find?', 'LiteRent can surface studio apartments, flats, and larger homes depending on available verified inventory.'],
      ['Can I apply directly from a listing?', 'Yes. Pending and verified homes can send renters straight into the application flow from the house details page.'],
      ['What if I do not see my preferred area yet?', 'Join the waitlist or keep checking the browse page as more Ibadan listings are added and verified.'],
    ],
    related: ['rent-in-ibadan', '2-bedroom-flats-for-rent-in-ibadan', '3-bedroom-houses-for-rent-in-ibadan', 'houses-for-rent-in-akobo-ibadan'],
  },
  {
    slug: 'cheap-houses-in-ibadan',
    title: 'Cheap Houses in Ibadan | Affordable Verified Homes | LiteRent',
    metaTitle: 'Cheap Houses in Ibadan | LiteRent',
    description: 'Searching for cheap houses in Ibadan? LiteRent highlights affordable verified homes and helps eligible renters move in with 30% upfront.',
    heading: 'Affordable houses in Ibadan',
    intro: 'Budget matters. LiteRent helps renters explore more affordable homes in Ibadan while still keeping the process structured, transparent, and easier to manage upfront.',
    heroTag: 'Budget-friendly homes',
    location: 'Ibadan',
    minRent: '',
    maxRent: '1200000',
    bedrooms: '',
    faq: [
      ['Does cheap always mean low quality?', 'Not necessarily. LiteRent aims to surface verified homes that fit different budgets while keeping quality and transparency in view.'],
      ['Can I still get the 30% upfront structure on lower-priced homes?', 'Eligible renters can still benefit from the LiteRent structure on homes that fit the product and approval criteria.'],
      ['What should I compare when looking for budget homes?', 'Compare location, transport links, bedrooms, total annual rent, and how the LiteRent payment structure affects your monthly plan.'],
    ],
    related: ['rent-in-ibadan', 'apartments-in-ibadan', '2-bedroom-flats-for-rent-in-ibadan', 'houses-for-rent-in-bodija-ibadan'],
  },
  {
    slug: 'verified-homes-in-ibadan',
    title: 'Verified Homes in Ibadan | LiteRent',
    metaTitle: 'Verified Homes in Ibadan | LiteRent',
    description: 'Explore verified homes in Ibadan on LiteRent and move in with 30% upfront if you are eligible.',
    heading: 'Verified homes in Ibadan',
    intro: 'Trust matters when renting. LiteRent is building a simpler way to discover verified homes in Ibadan and move forward with clearer next steps.',
    heroTag: 'Trust-first renting',
    location: 'Ibadan',
    minRent: '',
    maxRent: '',
    bedrooms: '',
    statusHint: 'verified',
    faq: [
      ['Why do verified homes matter?', 'Verified homes reduce uncertainty and help renters move forward with clearer information, pricing, and application expectations.'],
      ['Are sample homes the same as verified homes?', 'No. Sample homes are previews, while verified homes are the ones that are ready for the full LiteRent application process.'],
      ['Can I join the waitlist for sample homes?', 'Yes. Sample homes keep the waitlist path, while pending and verified homes can send you into the application flow.'],
    ],
    related: ['rent-in-ibadan', 'apartments-in-ibadan', 'houses-for-rent-in-jericho-ibadan'],
  },
  {
    slug: '2-bedroom-flats-for-rent-in-ibadan',
    title: '2 Bedroom Flats for Rent in Ibadan | LiteRent',
    metaTitle: '2 Bedroom Flats for Rent in Ibadan | LiteRent',
    description: 'Browse 2 bedroom flats for rent in Ibadan and see LiteRent homes that eligible renters can access with 30% upfront.',
    heading: '2 bedroom flats for rent in Ibadan',
    intro: 'Two-bedroom homes are popular for young families, flatmates, and growing professionals. LiteRent makes it easier to browse options in Ibadan with a more manageable move-in structure.',
    heroTag: '2 bedroom homes',
    location: 'Ibadan',
    bedrooms: '2',
    faq: [
      ['Who are 2 bedroom homes good for?', 'They work well for couples, small families, and renters who want an extra room for work, guests, or shared living.'],
      ['Can I filter by area too?', 'Yes. You can start here and then continue to the browse page or area pages for more local options.'],
      ['Does LiteRent show monthly estimates?', 'Yes. House pages and application stages can show the 30% upfront amount and the estimated monthly LiteRent plan.'],
    ],
    related: ['3-bedroom-houses-for-rent-in-ibadan', 'cheap-houses-in-ibadan', 'houses-for-rent-in-akobo-ibadan'],
  },
  {
    slug: '3-bedroom-houses-for-rent-in-ibadan',
    title: '3 Bedroom Houses for Rent in Ibadan | LiteRent',
    metaTitle: '3 Bedroom Houses for Rent in Ibadan | LiteRent',
    description: 'Find 3 bedroom houses for rent in Ibadan and explore LiteRent homes with verified details and a 30% upfront path for eligible renters.',
    heading: '3 bedroom houses for rent in Ibadan',
    intro: 'If you need more space for family life, work, or flexibility, LiteRent helps you browse 3 bedroom homes in Ibadan with clearer information and a simpler move-in plan.',
    heroTag: '3 bedroom homes',
    location: 'Ibadan',
    bedrooms: '3',
    faq: [
      ['Are 3 bedroom homes more expensive?', 'Usually yes, but the exact price depends on the area, finish, and overall property type. LiteRent helps you compare real listings more clearly.'],
      ['Can I still start with 30% upfront?', 'Eligible renters can use LiteRent’s structure on homes that fit approval and product requirements.'],
      ['What if I need an even larger home?', 'You can also check 4 bedroom pages or explore the main browse page for broader inventory.'],
    ],
    related: ['4-bedroom-houses-for-rent-in-ibadan', 'rent-in-ibadan', 'houses-for-rent-in-bodija-ibadan'],
  },
  {
    slug: '4-bedroom-houses-for-rent-in-ibadan',
    title: '4 Bedroom Houses for Rent in Ibadan | LiteRent',
    metaTitle: '4 Bedroom Houses for Rent in Ibadan | LiteRent',
    description: 'Find 4 bedroom houses for rent in Ibadan and explore spacious homes on LiteRent.',
    heading: '4 bedroom houses for rent in Ibadan',
    intro: 'Large households and renters who want extra room can use LiteRent to explore bigger homes in Ibadan with the same trust-first experience.',
    heroTag: '4 bedroom homes',
    location: 'Ibadan',
    bedrooms: '4',
    faq: [
      ['Who usually searches for 4 bedroom homes?', 'Larger families, multi-generational households, and renters who want more living space often start here.'],
      ['Can I compare this with 3 bedroom homes?', 'Yes. LiteRent’s related links and browse filters make it easier to compare nearby options.'],
      ['Does LiteRent handle only small homes?', 'No. The platform can support different property sizes as long as they fit the listing and operational model.'],
    ],
    related: ['3-bedroom-houses-for-rent-in-ibadan', 'houses-for-rent-in-jericho-ibadan', 'rent-in-ibadan'],
  },
  {
    slug: 'houses-for-rent-in-akobo-ibadan',
    title: 'Houses for Rent in Akobo Ibadan | LiteRent',
    metaTitle: 'Houses for Rent in Akobo Ibadan | LiteRent',
    description: 'Explore houses for rent in Akobo, Ibadan with LiteRent.',
    heading: 'Houses for rent in Akobo, Ibadan',
    intro: 'Akobo is one of the areas many renters search when looking for homes in Ibadan. LiteRent helps you browse homes there with clearer rental information and a better move-in structure for eligible renters.',
    heroTag: 'Area guide',
    location: 'Akobo',
    bedrooms: '',
    faq: [
      ['Why do renters like Akobo?', 'Many renters search Akobo because of its residential character and familiarity in the Ibadan market.'],
      ['Can I find different home sizes here?', 'Yes. Depending on inventory, you may see different bedroom counts and price points in the Akobo area.'],
      ['What if no homes are showing right now?', 'Use the browse page, join the waitlist, or check nearby Ibadan area pages while new listings are added.'],
    ],
    related: ['houses-for-rent-in-bodija-ibadan', 'houses-for-rent-in-jericho-ibadan', 'rent-in-ibadan'],
  },
  {
    slug: 'houses-for-rent-in-bodija-ibadan',
    title: 'Houses for Rent in Bodija Ibadan | LiteRent',
    metaTitle: 'Houses for Rent in Bodija Ibadan | LiteRent',
    description: 'Explore houses for rent in Bodija, Ibadan with LiteRent.',
    heading: 'Houses for rent in Bodija, Ibadan',
    intro: 'Bodija is a familiar search area for many renters. LiteRent helps you discover homes in Bodija with clearer property information and a structured application path.',
    heroTag: 'Area guide',
    location: 'Bodija',
    faq: [
      ['What kind of homes can I expect in Bodija?', 'Inventory changes over time, but LiteRent can surface homes in Bodija that match the platform’s verification and listing flow.'],
      ['Can I apply for a Bodija home directly?', 'Pending and verified homes can lead straight into the LiteRent application journey.'],
      ['Is Bodija only for premium homes?', 'No. Search intent around Bodija includes different renter budgets and property types.'],
    ],
    related: ['houses-for-rent-in-akobo-ibadan', 'cheap-houses-in-ibadan', 'rent-in-ibadan'],
  },
  {
    slug: 'houses-for-rent-in-jericho-ibadan',
    title: 'Houses for Rent in Jericho Ibadan | LiteRent',
    metaTitle: 'Houses for Rent in Jericho Ibadan | LiteRent',
    description: 'Explore houses for rent in Jericho, Ibadan with LiteRent.',
    heading: 'Houses for rent in Jericho, Ibadan',
    intro: 'Jericho is another strong search area within Ibadan. LiteRent helps you explore homes there with a trust-first process and a clearer route to applying.',
    heroTag: 'Area guide',
    location: 'Jericho',
    faq: [
      ['Can I see verified homes in Jericho?', 'Yes, where available, LiteRent can show verified homes and their next-step application paths.'],
      ['How do I compare Jericho with other areas?', 'Use LiteRent’s related pages and the browse page to compare areas, home sizes, and rental costs.'],
      ['What if I prefer another area of Ibadan?', 'Start with the main Ibadan rent page and explore linked neighborhood pages from there.'],
    ],
    related: ['verified-homes-in-ibadan', 'houses-for-rent-in-akobo-ibadan', 'rent-in-ibadan'],
  },
];

export const LANDING_MAP = Object.fromEntries(LANDING_PAGES.map((page) => [page.slug, page]));
